import { render, staticRenderFns } from "./CardSource.vue?vue&type=template&id=4be7b56f&scoped=true"
import script from "./CardSource.vue?vue&type=script&lang=js"
export * from "./CardSource.vue?vue&type=script&lang=js"
import style0 from "./CardSource.vue?vue&type=style&index=0&id=4be7b56f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be7b56f",
  null
  
)

export default component.exports